import { render, staticRenderFns } from "./Fight.vue?vue&type=template&id=af64c048&scoped=true&"
import script from "./Fight.vue?vue&type=script&lang=js&"
export * from "./Fight.vue?vue&type=script&lang=js&"
import style0 from "./Fight.vue?vue&type=style&index=0&id=af64c048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64c048",
  null
  
)

export default component.exports